<div class="collection-category-wrapper">
  <!-- DISPLAYING -->
  <div *ngIf="state === CategoryInputState.DISPLAYING && category"
    class="display"
    [class.no-delete]="serviceToDeleteFirst.length"
    [class.default]="category?.default"
  >
    <div class="category-row">
      <div class="category-info">
        <div *ngIf="category?.color" class="color" [ngStyle]="{ 'background-color': category?.color }">
        </div>
        <div *ngIf="category?.icon" class="icon-wrap">
          <span [class]="category?.icon"></span>
        </div>
        <div class="category-name">
          {{ categoryName }}
        </div>
      </div>
      <div class="category-actions" *ngIf="!category?.default">
        <button mat-icon-button [disabled]="disabled" (click)="edit()">
          <span [class]="Icon.EDIT"></span>
        </button>
        <button *ngIf="canDelete" mat-icon-button [disabled]="disabled" (click)="startDelete()">
          <span [class]="Icon.CLOSE"></span>
        </button>
      </div>
    </div>
  </div>
  <!-- EDITING -->
  <div *ngIf="state === CategoryInputState.EDITING" class="editing">
    <form [formGroup]="categoryForm">
      <div class="row">
        <div class="inputs">
          <app-bciti-color-select
            *ngIf="colors"
            formControlName="color"
            [colors]="colors"
          ></app-bciti-color-select>
          <app-bciti-icon-select
            *ngIf="icons"
            formControlName="icon"
            [icons]="icons"
          ></app-bciti-icon-select>
        </div>
        <button *ngIf="displayCloseButton" mat-icon-button type="button" [disabled]="loading || disabled" (click)="cancelEdit()">
          <span [class]="Icon.CLOSE"></span>
        </button>
      </div>
      <div class="section-translations" formGroupName="name">
        <div class="translation-inputs">
          <div *ngFor="let lang of langs" class="lang-input-wrapper">
            <app-form-input 
              type="text"
              placeholder="{{ propertyLabelInputTranslationsKey + 'placeholder' | translate }}"
              [class.error]="hasError(lang)"
              [charLimit]="characterLimit"
              [label]="(propertyLabelInputTranslationsKey + 'label' | translate) + ' ' + ('common.langsAbbr.' + lang | translate)"
              [formControlName]="lang"
              [hint]="textInputHint"
            >
            <app-form-error *ngIf="hasRequiredError(lang)">
              {{  propertyLabelInputTranslationsKey + 'errors.nameRequired' | translate }}
            </app-form-error>
          </app-form-input>
          </div>
        </div>
      </div>
      <div class="actions-wrapper">
        <button 
          type="button" 
          class="loading-button bciti-button bciti-button--blue-inversed"
          (click)="save()"
        >
          <mat-progress-spinner
            *ngIf="loading"
            diameter="18" 
            mode="indeterminate"
          ></mat-progress-spinner>
          <span>{{ 'common.save' | translate }}</span>
        </button>
      </div>
    </form>
  </div>
  <!-- DELETING -->
  <div *ngIf="state === CategoryInputState.DELETING" class="display deleting">
    <div class="category-row">
      <div class="category-info">
        <div *ngIf="category?.color" class="color" [ngStyle]="{ 'background-color': category?.color }">
        </div>
        <div *ngIf="category?.icon" class="icon-wrap">
          <span [class]="category?.icon"></span>
        </div>
        <div class="category-name">
          {{ categoryName }}
        </div>
      </div>
    </div>
    <div class="extra-row">
      <div class="confirm-delete">
        <span class="warning">{{ propertyLabelInputTranslationsKey + 'deleteWarning' | translate }}</span>
        <div class="confirm-actions">
          <button 
            class="bciti-button bciti-button--blue-inversed"
            [ngClass]="{'is-confirm-cancel-area': propertyLabelInput === PropertyLabelInput.AREA}"
           (click)="cancelDelete()">
            {{ (propertyLabelInput === PropertyLabelInput.AREA ?  'common.no' : 'common.cancel') | translate }}
          </button>
          <button 
            class="bciti-button bciti-button--red loading-button confirm" 
            [ngClass]="{'is-confirm-cancel-area': propertyLabelInput === PropertyLabelInput.AREA}"
            (click)="confirmDelete()">
            <mat-progress-spinner
              *ngIf="loading"
              diameter="18" 
              mode="indeterminate"
            ></mat-progress-spinner>
            {{ (propertyLabelInput === PropertyLabelInput.AREA ?  'common.yes' : 'common.delete') | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="no-deletion" *ngIf="serviceToDeleteFirst.length">
<span> {{ propertyLabelInputTranslationsKey + 'errors.no-deletion' | translate }} </span>
  <ul>
    <li *ngFor="let service of serviceToDeleteFirst">
      <span >{{service}}</span>
    </li>
  </ul>
</div>

